export const NOTICE_CATEGORIES = Object.freeze({
  REGULATION: Object.freeze(
    { label: '運転規制', value: 0 },
  ),
  ATTENTION: Object.freeze(
    { label: '注意喚起情報', value: 1 },
  ),
});

export const NOTICE_TYPES = Object.freeze({
  THIRTY_FIVE_LIMIT: Object.freeze(
    { label: '速度規制 35km/h', detailLabel: '速度 35km/h 以下', value: 0 },
  ),
  TWENTY_FIVE_LIMIT: Object.freeze(
    { label: '速度規制 25km/h', detailLabel: '速度 25km/h 以下', value: 1 },
  ),
  SUSPENSION: Object.freeze(
    { label: '運転中止', detailLabel: '運転中止', value: 2 },
  ),
  LIMIT_CANCEL: Object.freeze(
    { label: '速度規制解除', detailLabel: '規制解除', value: 3 },
  ),
  SUSPENSION_CANCEL: Object.freeze(
    { label: '運転中止解除', detailLabel: '規制解除', value: 4 },
  ),
  SLOWDOWN: Object.freeze(
    { label: '計画徐行', detailLabel: '計画徐行', value: 5 },
  ),
});

export const REASONS = Object.freeze({
  RAIN: Object.freeze({ label: '雨', value: 0 }),
  WIND: Object.freeze({ label: '風', value: 1 }),
  FLOOD: Object.freeze({ label: '水位', value: 2 }),
  NULL: Object.freeze({ label: '記載なし', value: -1 }),
});

export const ACCOUNT_TYPES = Object.freeze({
  DRIVER: Object.freeze({ label: '運転士', value: 0 }),
  TRAINER: Object.freeze({ label: '指導担当', value: 1 }),
});

export const OPERATION_TYPES = Object.freeze({
  START: Object.freeze({ label: '運行開始', value: 0 }),
  FINISH: Object.freeze({ label: '運行終了', value: 1 }),
  RECEIVE_NOTICE: Object.freeze({ label: '通告受信', value: 2 }),
  TAP_NOTICE: Object.freeze({ label: '通告タップ', value: 3 }),
  TAP_RECEIPT: Object.freeze({ label: '受領タップ', value: 4 }),
  MARK: Object.freeze({ label: 'マーカー設定', value: 5 }),
  REMOVE_MARKER: Object.freeze({ label: 'マーカー解除', value: 6 }),
});

export const SORT_CATEGORIES = Object.freeze({
  CREATED_DESC: '作成日時が新しい順',
  CREATED_ASC: '作成日時が古い順',
  EMPLOYEE_NUMBER_ASC: '社員番号順',
  EMPLOYEE_NAME_ASC: '氏名50音順',
  CORRECT_ANSWER_DESC: '正答数が多い順',
  CORRECT_ANSWER_ASC: '正答数が少ない順',
  SECTION_NUMBER_ASC: '線区順',
  SECTION_NUMBER_DESC: '線区逆順',
  NOTICE_CATEGORIES_ASC: '運転規制優先',
  NOTICE_CATEGORIES_DESC: '注意喚起情報優先',
  TRAINED_DESC: '受講日時が新しい順',
  TRAINED_ASC: '受講日時が古い順',
  EC_DESC: 'ECが新しい順',
  EC_ASC: 'ECが古い順',
});
